import { Buffer } from 'buffer';

import { useSzafir } from '../../../common/hooks/useSzafir';
import { useSpdCore } from '../../../common/hooks/useSpdCore';

export async function signJudgmentPdfWithSzafir(
  szafir: ReturnType<typeof useSzafir>,
  spd: ReturnType<typeof useSpdCore>,
  pin: string,
  judgmentId: string,
  judgmentNumber: string,
  english = false,
): Promise<void> {
  const taskList = await spd.szafir.getTaskListForJudgment(judgmentId, english);

  const szafirResult = await new Promise<Buffer | null>((resolve, reject) => {
    void szafir.signDocument(
      taskList,
      pin,
      judgmentId,
      judgmentNumber,
      english,
      result => resolve(result),
      error =>
        reject({
          response: new Error('Podpis Szafir nie powiódł się: ' + error),
        }),
    );
  });
  if (!szafirResult) {
    throw { response: new Error('Brak podpisanego dokumentu z Szafir') };
  }
  await spd.savedPdfs.savePdfFileForJudgment({
    entityId: judgmentId,
    file: szafirResult,
    english,
  });
}
